import { c as _c } from "react/compiler-runtime";
import { ContactFieldValueInterface, ContactSlugEnum, FormInput, FormInputPhone, Modal, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { ManageFieldsEditErrorResponseInterface, ManageFieldsInterface } from 'modules/contacts/components/update-fields-modal/types/manage-fields-interface';
import UpdateFieldsModalSkeleton from 'modules/contacts/components/update-fields-modal/update-fields-modal-skeleton';
import React, { ChangeEvent, useEffect } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { KeyedMutator } from 'swr';
import { SaveIcon } from '@systemeio/ui/icons';
interface UpdateFieldsModalProps {
  opened: boolean;
  data: ManageFieldsInterface | undefined;
  onClose: () => void;
  title: string;
  isLoadingFields: boolean;
  isFetching: boolean;
  updateFields: (data: ManageFieldsInterface) => Promise<void>;
  mutate: KeyedMutator<ManageFieldsInterface>;
  unusedFields?: (data: ManageFieldsInterface | undefined) => undefined | {
    id: number;
    fieldValues: ContactFieldValueInterface[];
  };
}
function UpdateFieldsModal(t0) {
  const $ = _c(31);
  const {
    opened,
    onClose,
    isLoadingFields,
    isFetching,
    title,
    updateFields,
    mutate,
    data,
    unusedFields
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = React.useState();
  const [errors, setErrors] = React.useState();
  let t1;
  if ($[0] !== data || $[1] !== unusedFields) {
    t1 = () => {
      if (data && unusedFields) {
        setTempState(unusedFields(data));
      }
    };
    $[0] = data;
    $[1] = unusedFields;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== data) {
    t2 = [data];
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function onChangeField(e, index) {
      const value = typeof e === "string" ? e : e.target.value;
      setTempState(prev => {
        if (!prev) {
          return prev;
        }
        const updatedFieldValues = [...prev.fieldValues];
        updatedFieldValues[index] = {
          ...updatedFieldValues[index],
          value
        };
        return {
          ...prev,
          fieldValues: updatedFieldValues
        };
      });
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onChangeField = t3;
  let t4;
  if ($[6] !== mutate || $[7] !== onClose || $[8] !== t || $[9] !== tempState || $[10] !== updateFields) {
    t4 = async function onSubmit() {
      ;
      try {
        if (tempState) {
          setErrors(undefined);
          await updateFields(tempState);
          await mutate(tempState);
          onClose();
          toast.success(t("global.changes_saved"));
        }
      } catch (t5) {
        const error = t5;
        if (error instanceof BadRequest) {
          setErrors(error.errors);
        } else {
          toast.error(t("global.error"));
        }
      }
    };
    $[6] = mutate;
    $[7] = onClose;
    $[8] = t;
    $[9] = tempState;
    $[10] = updateFields;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onSubmit = t4;
  let t5;
  if ($[12] !== errors?.fields?.fields || $[13] !== isLoadingFields || $[14] !== tempState?.fieldValues) {
    t5 = isLoadingFields ? <UpdateFieldsModalSkeleton /> : tempState?.fieldValues.map((item, index_0) => {
      const Input = item.contactField.slug === ContactSlugEnum.PhoneNumber ? FormInputPhone : FormInput;
      return <Input key={`${item.contactField.slug}-${index_0}`} label={item.contactField.fieldName} value={item.value || ""} onChange={e_0 => onChangeField(e_0, index_0)} error={errors?.fields?.fields[item.contactField.slug]?.join("\n")} />;
    });
    $[12] = errors?.fields?.fields;
    $[13] = isLoadingFields;
    $[14] = tempState?.fieldValues;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = isFetching || isLoadingFields;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SaveIcon />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("global.save");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isFetching || $[20] !== onSubmit || $[21] !== t6 || $[22] !== t8) {
    t9 = <PrimaryButton width="large" className="mx-auto w-fit" isFetching={t6} disabled={isFetching} onClick={onSubmit}>{t7}{t8}</PrimaryButton>;
    $[19] = isFetching;
    $[20] = onSubmit;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== isFetching || $[25] !== onClose || $[26] !== opened || $[27] !== t5 || $[28] !== t9 || $[29] !== title) {
    t10 = <Modal opened={opened} onClose={onClose} title={title} isFetching={isFetching} contentClassName="flex flex-col gap-7">{t5}{t9}</Modal>;
    $[24] = isFetching;
    $[25] = onClose;
    $[26] = opened;
    $[27] = t5;
    $[28] = t9;
    $[29] = title;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
export default UpdateFieldsModal;